import React, { useEffect } from "react";
import commonUI from "../utils/commonUI.jsx";
import { NeuroMessage, useAnalytics } from '@ignitesales/neuro-application';
import { Modal } from "@ignitesales/neuro-application/src/neuro-ui";
import { useNeuroMessages } from "@ignitesales/neuro-application";
import Collapsible from "react-collapsible";

const PromoModal = ({ isOpen, onClose }) => {
    const { getMessage } = useNeuroMessages();
    const { actionCompleted } = useAnalytics();

    useEffect(() => {
        // The accordian is not scrolling to the top when expanded. 
        // This is a workaround to fix that.
        var accordionTriggers = document.querySelector('.promo-modal__body').querySelectorAll('.Collapsible__trigger');
        
        accordionTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function() {
                console.log('stuff');
                var accordionContainer = trigger.closest('.Collapsible');
                var promoModalBody = accordionContainer.closest('.promo-modal__body');
                // because the offset is calculated as soon as the line is executed and 
                // not after the transition is complete, we need to add a delay
                setTimeout(function() {
                    var isExpanded = trigger.classList.contains('is-open');
                    var scrollToPosition = accordionContainer.offsetTop;
                    if (isExpanded) {
                        promoModalBody.scrollTo({
                          top: scrollToPosition,
                          behavior: 'smooth'
                        });
                    }
                  }, 400);
            });
        });
    }, [])

    const applyClicked = () => {
        actionCompleted({ actionName: 'promoApplyClicked' });
    };

    const learnMoreClicked = () => {
        actionCompleted({ actionName: 'promoLearnMoreClicked' });
    };

    const renderPromoOffers = () => {
        const offerCount = getMessage('promo.offerDetails.count');
        const offers = [];
        for (let i = 1; i <= offerCount; i++) {
            const offerDetailsCount = getMessage(`promo.offerDetails.${i}.count`);
            const offerDetails = [];
            for (let j = 1; j <= offerDetailsCount; j++) {
                offerDetails.push(<li key={`${i}-${j}`}><NeuroMessage id={`promo.offerDetails.${i}.${j}`} /></li>);
            };
            const isOpen = i === 1;
            offers.push(
                <Collapsible open={isOpen} trigger={<div classNames="product_features_header"><NeuroMessage id={`promo.offerDetails.${i}.header`} /></div>}>
                    <ul>{offerDetails}</ul>
                </Collapsible>
            );
        }
        return offers;
    }

    const renderPromoFooter = () => (<div className="promo-modal__footer">
        <a onClick={applyClicked} className="btn btn-primary" href={getMessage('promo.openOnline.link')} target="_blank"><NeuroMessage id='product.applyBtn' /></a>
        <a onClick={learnMoreClicked} className="btn btn-primary learn-more" href={getMessage('promo.learnMore.link')} target="_blank"><NeuroMessage id='product.learnMore' /></a>
    </div>);

    return <>
        <Modal
            show={isOpen}
            className="summary-modal"
            title={null}
            onClose={onClose}
            nodeId="root"
            closeBtn={commonUI.closeButton}
        >
            <div className="promo-modal__header">
                <img src="/classpath/assets/images/promo-header.jpg" />
                <span><NeuroMessage id="promo.header.title"></NeuroMessage></span>
            </div>
            <div className="promo-modal__body">
                {renderPromoOffers()}
                <NeuroMessage className="promo-disclosure" id="promo.body.disclosure" tagName="span"/>
            </div>
            <div className="promo-modal__footer">
                {renderPromoFooter()}
            </div>
        </Modal>
    </>;
};

export default PromoModal;
